import React, { useState, useEffect } from 'react'
//components
import Select from "react-select"
import { Button } from "../../../components/ui/buttons/Button"
import { UserForm } from "./userComponents/UserForm"
import Label from '../../../components/ui/labels/Label'
//hooks/context
import useUserOptions  from "../../../hooks/useUserOptions"

/**
 * Can view all users if admin, displays component with user data when a user is selected
 * 
 * @returns {JSX.Element}
 * 
 * @category Components - Admin Dashboard
 */
export const Users = () => {
    const [showUserForm, setShowUserForm] = useState(false)
    const [selectedUser, setSelectedUser] = useState(null)
    const [isAddNewUser, setIsAddNewUser] = useState(false)

    const {userNameOptions, setUserNameOptions, fetchAllUsers} = useUserOptions()

    //fetch user options when page loads
    useEffect(() => {
        fetchAllUsers()
    }, []) //eslint-disable-line

    useEffect(() => {
        if(selectedUser){
            setShowUserForm(true)

        }
    }, [selectedUser])

    return (

        <>
            {!isAddNewUser ? (
                <>
                    {/* add new user button */}
                    <div className='flex justify-end'>
                        <Button 
                            variant='success' 
                            onClick={() =>  {
                                setSelectedUser(null)
                                setShowUserForm(true)
                                setIsAddNewUser(true)
                                }} 
                            className='mb-4'>
                                <i className="fa-solid fa-circle-plus mr-2"></i>Add New User
                        </Button>
                    </div>

                    {/* select a user from dropdown  */}
                    <Label>Select user</Label>
                    <div className='max-w-md mb-10'>
                        <Select
                            value={selectedUser}
                            options={userNameOptions}
                            name="userDropdown"
                            onChange={(x) => setSelectedUser(x)}
                            menuPosition='fixed'
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            placeholder="Select user..."
                        />
                    </div>

            </>
            ) : null}


            {/* form to view or add user */}
            {showUserForm && (isAddNewUser || selectedUser)
                ? <UserForm 
                    selectedUser={selectedUser} 
                    setSelectedUser={setSelectedUser} 
                    setUserNameOptions={setUserNameOptions}
                    setShowUserForm={setShowUserForm}
                    isAddNewUser={isAddNewUser}
                    setIsAddNewUser={setIsAddNewUser}
                /> 
                : null 
            }

        </>

    )
}